export default "__VITE_ASSET__CBbXIF5S__"